export const sealCheck = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1528_2322)">
      <path
        d="M18.1163 6.42625C17.8806 6.18 17.6369 5.92625 17.545 5.70312C17.46 5.49875 17.455 5.16 17.45 4.83187C17.4406 4.22187 17.4306 3.53062 16.95 3.05C16.4694 2.56937 15.7781 2.55937 15.1681 2.55C14.84 2.545 14.5013 2.54 14.2969 2.455C14.0744 2.36312 13.82 2.11937 13.5737 1.88375C13.1425 1.46937 12.6525 1 12 1C11.3475 1 10.8581 1.46937 10.4262 1.88375C10.18 2.11937 9.92625 2.36312 9.70312 2.455C9.5 2.54 9.16 2.545 8.83187 2.55C8.22187 2.55937 7.53062 2.56937 7.05 3.05C6.56937 3.53062 6.5625 4.22187 6.55 4.83187C6.545 5.16 6.54 5.49875 6.455 5.70312C6.36312 5.92562 6.11937 6.18 5.88375 6.42625C5.46937 6.8575 5 7.3475 5 8C5 8.6525 5.46937 9.14187 5.88375 9.57375C6.11937 9.82 6.36312 10.0737 6.455 10.2969C6.54 10.5013 6.545 10.84 6.55 11.1681C6.55937 11.7781 6.56937 12.4694 7.05 12.95C7.53062 13.4306 8.22187 13.4406 8.83187 13.45C9.16 13.455 9.49875 13.46 9.70312 13.545C9.92562 13.6369 10.18 13.8806 10.4262 14.1163C10.8575 14.5306 11.3475 15 12 15C12.6525 15 13.1419 14.5306 13.5737 14.1163C13.82 13.8806 14.0737 13.6369 14.2969 13.545C14.5013 13.46 14.84 13.455 15.1681 13.45C15.7781 13.4406 16.4694 13.4306 16.95 12.95C17.4306 12.4694 17.4406 11.7781 17.45 11.1681C17.455 10.84 17.46 10.5013 17.545 10.2969C17.6369 10.0744 17.8806 9.82 18.1163 9.57375C18.5306 9.1425 19 8.6525 19 8C19 7.3475 18.5306 6.85812 18.1163 6.42625ZM14.8538 6.85375L11.3538 10.3538C11.3073 10.4002 11.2522 10.4371 11.1915 10.4623C11.1308 10.4874 11.0657 10.5004 11 10.5004C10.9343 10.5004 10.8692 10.4874 10.8085 10.4623C10.7478 10.4371 10.6927 10.4002 10.6462 10.3538L9.14625 8.85375C9.09979 8.8073 9.06294 8.75214 9.0378 8.69145C9.01266 8.63075 8.99972 8.5657 8.99972 8.5C8.99972 8.4343 9.01266 8.36925 9.0378 8.30855C9.06294 8.24786 9.09979 8.1927 9.14625 8.14625C9.24007 8.05243 9.36732 7.99972 9.5 7.99972C9.5657 7.99972 9.63075 8.01266 9.69145 8.0378C9.75214 8.06294 9.8073 8.09979 9.85375 8.14625L11 9.29313L14.1462 6.14625C14.1927 6.09979 14.2479 6.06294 14.3086 6.0378C14.3692 6.01266 14.4343 5.99972 14.5 5.99972C14.5657 5.99972 14.6308 6.01266 14.6914 6.0378C14.7521 6.06294 14.8073 6.09979 14.8538 6.14625C14.9002 6.1927 14.9371 6.24786 14.9622 6.30855C14.9873 6.36925 15.0003 6.4343 15.0003 6.5C15.0003 6.5657 14.9873 6.63075 14.9622 6.69145C14.9371 6.75214 14.9002 6.8073 14.8538 6.85375Z"
        fill="#039D53"
      />
      <path
        d="M12 0.5C12.8873 0.5 13.5213 1.14032 13.9189 1.52246L14.0996 1.69238C14.1568 1.74537 14.2114 1.79445 14.2646 1.83887C14.3753 1.9311 14.4473 1.97658 14.4873 1.99316H14.4893L14.5664 2.01367C14.6052 2.02102 14.6582 2.02845 14.7275 2.03418C14.8588 2.04501 15.0078 2.04724 15.1758 2.0498L15.6553 2.06348C16.1813 2.09465 16.8178 2.21039 17.3037 2.69629L17.417 2.82129C17.9497 3.45766 17.9421 4.29471 17.9502 4.82422L17.9658 5.27246C17.9716 5.34182 17.979 5.39476 17.9863 5.43359L18.0068 5.51074L18.0078 5.5127L18.0557 5.59766C18.0804 5.63456 18.115 5.68003 18.1611 5.73535C18.2498 5.84163 18.356 5.9541 18.4766 6.08008L18.7979 6.42285C19.1392 6.81064 19.5 7.33395 19.5 8C19.5 8.88724 18.8587 9.52032 18.4766 9.91797L18.4775 9.91895C18.3569 10.045 18.25 10.1581 18.1611 10.2646C18.0689 10.3753 18.0234 10.4473 18.0068 10.4873V10.4893C17.9952 10.5174 17.9772 10.5896 17.9658 10.7275L17.9502 11.1758C17.9415 11.7406 17.9515 12.6559 17.3037 13.3037C16.8178 13.7896 16.1813 13.9053 15.6553 13.9365L15.1758 13.9502C15.0078 13.9528 14.8588 13.955 14.7275 13.9658C14.5896 13.9772 14.5174 13.9952 14.4893 14.0068L14.4873 14.0078C14.4473 14.0243 14.3752 14.0689 14.2646 14.1611C14.1582 14.25 14.0452 14.3567 13.9189 14.4775C13.5212 14.8592 12.8874 15.5 12 15.5C11.1127 15.5 10.4787 14.8597 10.0811 14.4775L9.90039 14.3076C9.84324 14.2546 9.78862 14.2055 9.73535 14.1611C9.62473 14.0689 9.55271 14.0234 9.5127 14.0068H9.51074C9.48265 13.9952 9.41044 13.9772 9.27246 13.9658L8.82422 13.9502C8.29471 13.9421 7.45766 13.9497 6.82129 13.417L6.69629 13.3037C6.21039 12.8178 6.09465 12.1813 6.06348 11.6553L6.0498 11.1758C6.04724 11.0078 6.04501 10.8588 6.03418 10.7275C6.02278 10.5896 6.00477 10.5174 5.99316 10.4893L5.99219 10.4873C5.97568 10.4473 5.93109 10.3752 5.83887 10.2646C5.75002 10.1582 5.64329 10.0452 5.52246 9.91895V9.91797C5.14073 9.52019 4.5 8.88707 4.5 8C4.5 7.11201 5.14141 6.47766 5.52344 6.08008C5.64376 5.95433 5.75019 5.8417 5.83887 5.73535C5.9311 5.62473 5.97658 5.55271 5.99316 5.5127V5.51074L6.01367 5.43359C6.02102 5.39476 6.02845 5.34182 6.03418 5.27246C6.04501 5.14121 6.04724 4.99221 6.0498 4.82422V4.82129L6.06445 4.34473C6.09599 3.82008 6.21032 3.18226 6.69629 2.69629L6.82129 2.58301C7.45766 2.05032 8.29471 2.05794 8.82422 2.0498L9.27344 2.03418C9.41149 2.02277 9.48286 2.00527 9.50977 1.99414L9.5127 1.99219L9.59766 1.94434C9.63456 1.91961 9.68003 1.88502 9.73535 1.83887C9.84184 1.75002 9.95478 1.64329 10.0811 1.52246C10.4788 1.14079 11.1126 0.5 12 0.5Z"
        stroke="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1528_2322"
        x="0"
        y="0"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1528_2322"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1528_2322"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const viewIcon = (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1664_3598)">
      <path
        d="M8.63493 6.375C8.07134 6.375 7.53084 6.59888 7.13233 6.9974C6.73381 7.39591 6.50993 7.93641 6.50993 8.5C6.50993 9.06358 6.73381 9.60409 7.13233 10.0026C7.53084 10.4011 8.07134 10.625 8.63493 10.625C9.19851 10.625 9.73902 10.4011 10.1375 10.0026C10.536 9.60409 10.7599 9.06358 10.7599 8.5C10.7599 7.93641 10.536 7.39591 10.1375 6.9974C9.73902 6.59888 9.19851 6.375 8.63493 6.375ZM8.63493 12.0417C7.69562 12.0417 6.79478 11.6685 6.13059 11.0043C5.4664 10.3401 5.09326 9.43931 5.09326 8.5C5.09326 7.56069 5.4664 6.65985 6.13059 5.99566C6.79478 5.33147 7.69562 4.95833 8.63493 4.95833C9.57424 4.95833 10.4751 5.33147 11.1393 5.99566C11.8035 6.65985 12.1766 7.56069 12.1766 8.5C12.1766 9.43931 11.8035 10.3401 11.1393 11.0043C10.4751 11.6685 9.57424 12.0417 8.63493 12.0417ZM8.63493 3.1875C5.09326 3.1875 2.06868 5.39042 0.843262 8.5C2.06868 11.6096 5.09326 13.8125 8.63493 13.8125C12.1766 13.8125 15.2012 11.6096 16.4266 8.5C15.2012 5.39042 12.1766 3.1875 8.63493 3.1875Z"
        fill="#4C4C4C"
        fill-opacity="0.48"
      />
    </g>
    <defs>
      <clipPath id="clip0_1664_3598">
        <rect
          width="17"
          height="17"
          fill="white"
          transform="translate(0.133301)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const editIcon = (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.19165 14.875V11.8646L11.5417 2.53229C11.6833 2.40243 11.8399 2.30208 12.0113 2.23125C12.1827 2.16042 12.3626 2.125 12.551 2.125C12.7394 2.125 12.9224 2.16042 13.1 2.23125C13.2775 2.30208 13.431 2.40833 13.5604 2.55L14.5344 3.54167C14.676 3.67153 14.7794 3.825 14.8446 4.00208C14.9098 4.17917 14.9421 4.35625 14.9417 4.53333C14.9417 4.72222 14.9093 4.90237 14.8446 5.07379C14.7799 5.24521 14.6765 5.40151 14.5344 5.54271L5.20207 14.875H2.19165ZM12.5333 5.525L13.525 4.53333L12.5333 3.54167L11.5417 4.53333L12.5333 5.525Z"
      fill="#212121"
    />
  </svg>
);

export const deleteIcon = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1647 3.5415C14.3526 3.5415 14.5327 3.61613 14.6656 3.74897C14.7984 3.88181 14.873 4.06198 14.873 4.24984C14.873 4.4377 14.7984 4.61787 14.6656 4.7507C14.5327 4.88354 14.3526 4.95817 14.1647 4.95817H13.4564L13.4543 5.00846L12.7934 14.2671C12.7679 14.6245 12.608 14.959 12.3458 15.2032C12.0836 15.4474 11.7386 15.5832 11.3803 15.5832H5.61513C5.25681 15.5832 4.9118 15.4474 4.64959 15.2032C4.38738 14.959 4.22745 14.6245 4.20201 14.2671L3.54113 5.00917L3.53971 4.95817H2.83138C2.64352 4.95817 2.46335 4.88354 2.33051 4.7507C2.19767 4.61787 2.12305 4.4377 2.12305 4.24984C2.12305 4.06198 2.19767 3.88181 2.33051 3.74897C2.46335 3.61613 2.64352 3.5415 2.83138 3.5415H14.1647ZM9.91471 1.4165C10.1026 1.4165 10.2827 1.49113 10.4156 1.62397C10.5484 1.75681 10.623 1.93698 10.623 2.12484C10.623 2.3127 10.5484 2.49287 10.4156 2.6257C10.2827 2.75854 10.1026 2.83317 9.91471 2.83317H7.08138C6.89352 2.83317 6.71335 2.75854 6.58051 2.6257C6.44767 2.49287 6.37305 2.3127 6.37305 2.12484C6.37305 1.93698 6.44767 1.75681 6.58051 1.62397C6.71335 1.49113 6.89352 1.4165 7.08138 1.4165H9.91471Z"
      fill="#9B0505"
    />
  </svg>
);

export const closeIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8228 3.18326C10.7667 3.12701 10.7 3.08238 10.6266 3.05193C10.5532 3.02148 10.4745 3.00581 10.395 3.00581C10.3155 3.00581 10.2369 3.02148 10.1634 3.05193C10.09 3.08238 10.0234 3.12701 9.96722 3.18326L7 6.14442L4.03278 3.1772C3.9766 3.12102 3.90991 3.07646 3.8365 3.04605C3.7631 3.01565 3.68443 3 3.60499 3C3.52554 3 3.44687 3.01565 3.37347 3.04605C3.30007 3.07646 3.23337 3.12102 3.1772 3.1772C3.12102 3.23337 3.07646 3.30007 3.04605 3.37347C3.01565 3.44687 3 3.52554 3 3.60499C3 3.68443 3.01565 3.7631 3.04605 3.8365C3.07646 3.90991 3.12102 3.9766 3.1772 4.03278L6.14442 7L3.1772 9.96722C3.12102 10.0234 3.07646 10.0901 3.04605 10.1635C3.01565 10.2369 3 10.3156 3 10.395C3 10.4745 3.01565 10.5531 3.04605 10.6265C3.07646 10.6999 3.12102 10.7666 3.1772 10.8228C3.23337 10.879 3.30007 10.9235 3.37347 10.9539C3.44687 10.9844 3.52554 11 3.60499 11C3.68443 11 3.7631 10.9844 3.8365 10.9539C3.90991 10.9235 3.9766 10.879 4.03278 10.8228L7 7.85558L9.96722 10.8228C10.0234 10.879 10.0901 10.9235 10.1635 10.9539C10.2369 10.9844 10.3156 11 10.395 11C10.4745 11 10.5531 10.9844 10.6265 10.9539C10.6999 10.9235 10.7666 10.879 10.8228 10.8228C10.879 10.7666 10.9235 10.6999 10.9539 10.6265C10.9844 10.5531 11 10.4745 11 10.395C11 10.3156 10.9844 10.2369 10.9539 10.1635C10.9235 10.0901 10.879 10.0234 10.8228 9.96722L7.85558 7L10.8228 4.03278C11.0534 3.80219 11.0534 3.41385 10.8228 3.18326Z"
      fill="#AA232F"
    />
  </svg>
);

export const infoIcon = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33333 12.5C8.56944 12.5 8.7675 12.42 8.9275 12.26C9.08694 12.1006 9.16667 11.9028 9.16667 11.6667V8.3125C9.16667 8.07639 9.08694 7.88194 8.9275 7.72917C8.7675 7.57639 8.56944 7.5 8.33333 7.5C8.09722 7.5 7.89944 7.57972 7.74 7.73917C7.58 7.89917 7.5 8.09722 7.5 8.33333V11.6875C7.5 11.9236 7.58 12.1181 7.74 12.2708C7.89944 12.4236 8.09722 12.5 8.33333 12.5ZM8.33333 5.83333C8.56944 5.83333 8.7675 5.75333 8.9275 5.59333C9.08694 5.43389 9.16667 5.23611 9.16667 5C9.16667 4.76389 9.08694 4.56583 8.9275 4.40583C8.7675 4.24639 8.56944 4.16667 8.33333 4.16667C8.09722 4.16667 7.89944 4.24639 7.74 4.40583C7.58 4.56583 7.5 4.76389 7.5 5C7.5 5.23611 7.58 5.43389 7.74 5.59333C7.89944 5.75333 8.09722 5.83333 8.33333 5.83333ZM8.33333 16.6667C7.18056 16.6667 6.09722 16.4478 5.08333 16.01C4.06944 15.5728 3.1875 14.9792 2.4375 14.2292C1.6875 13.4792 1.09389 12.5972 0.656667 11.5833C0.218889 10.5694 0 9.48611 0 8.33333C0 7.18056 0.218889 6.09722 0.656667 5.08333C1.09389 4.06944 1.6875 3.1875 2.4375 2.4375C3.1875 1.6875 4.06944 1.09361 5.08333 0.655833C6.09722 0.218611 7.18056 0 8.33333 0C9.48611 0 10.5694 0.218611 11.5833 0.655833C12.5972 1.09361 13.4792 1.6875 14.2292 2.4375C14.9792 3.1875 15.5728 4.06944 16.01 5.08333C16.4478 6.09722 16.6667 7.18056 16.6667 8.33333C16.6667 9.48611 16.4478 10.5694 16.01 11.5833C15.5728 12.5972 14.9792 13.4792 14.2292 14.2292C13.4792 14.9792 12.5972 15.5728 11.5833 16.01C10.5694 16.4478 9.48611 16.6667 8.33333 16.6667ZM8.33333 15C10.1806 15 11.7536 14.3508 13.0525 13.0525C14.3508 11.7536 15 10.1806 15 8.33333C15 6.48611 14.3508 4.91306 13.0525 3.61417C11.7536 2.31583 10.1806 1.66667 8.33333 1.66667C6.48611 1.66667 4.91333 2.31583 3.615 3.61417C2.31611 4.91306 1.66667 6.48611 1.66667 8.33333C1.66667 10.1806 2.31611 11.7536 3.615 13.0525C4.91333 14.3508 6.48611 15 8.33333 15Z"
      fill="#98B7DA"
    />
  </svg>
);

export const uploadIcon = (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.05295 16.6295H8.94709V12.6755L10.4624 14.1908L11.7883 12.8412L8.00002 9.05293L4.21174 12.8412L5.56132 14.1671L7.05295 12.6755V16.6295ZM0.423462 19.4707V0.529297H9.89416L15.5766 6.21172V19.4707H0.423462ZM8.94709 7.15879H13.6824L8.94709 2.42344V7.15879Z"
      fill="#0A1D39"
    />
  </svg>
);

export const governmentalIcon = (
  <svg
    width="38"
    height="33"
    viewBox="0 0 38 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.9998 22H26.3332V25.6667H29.9998M29.9998 14.6667H26.3332V18.3333H29.9998M33.6665 29.3333H18.9998V25.6667H22.6665V22H18.9998V18.3333H22.6665V14.6667H18.9998V11H33.6665M15.3332 7.33333H11.6665V3.66667H15.3332M15.3332 14.6667H11.6665V11H15.3332M15.3332 22H11.6665V18.3333H15.3332M15.3332 29.3333H11.6665V25.6667H15.3332M7.99984 7.33333H4.33317V3.66667H7.99984M7.99984 14.6667H4.33317V11H7.99984M7.99984 22H4.33317V18.3333H7.99984M7.99984 29.3333H4.33317V25.6667H7.99984M18.9998 7.33333V0H0.666504V33H37.3332V7.33333H18.9998Z"
      fill="#212121"
    />
  </svg>
);

export const organizationIcon = (
  <svg
    width="81"
    height="73"
    viewBox="0 0 81 73"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M64.2498 48.375H56.3332V56.2917H64.2498M64.2498 32.5417H56.3332V40.4583H64.2498M72.1665 64.2083H40.4998V56.2917H48.4165V48.375H40.4998V40.4583H48.4165V32.5417H40.4998V24.625H72.1665M32.5832 16.7083H24.6665V8.79167H32.5832M32.5832 32.5417H24.6665V24.625H32.5832M32.5832 48.375H24.6665V40.4583H32.5832M32.5832 64.2083H24.6665V56.2917H32.5832M16.7498 16.7083H8.83317V8.79167H16.7498M16.7498 32.5417H8.83317V24.625H16.7498M16.7498 48.375H8.83317V40.4583H16.7498M16.7498 64.2083H8.83317V56.2917H16.7498M40.4998 16.7083V0.875H0.916504V72.125H80.0832V16.7083H40.4998Z"
      fill="#E90102"
    />
  </svg>
);

export const personIcon = (
  <svg
    width="95"
    height="95"
    viewBox="0 0 95 95"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M66.3327 38.0833C66.3327 43.0782 64.3485 47.8686 60.8165 51.4005C57.2846 54.9324 52.4943 56.9167 47.4993 56.9167C42.5044 56.9167 37.7141 54.9324 34.1822 51.4005C30.6502 47.8686 28.666 43.0782 28.666 38.0833C28.666 33.0884 30.6502 28.2981 34.1822 24.7662C37.7141 21.2342 42.5044 19.25 47.4993 19.25C52.4943 19.25 57.2846 21.2342 60.8165 24.7662C64.3485 28.2981 66.3327 33.0884 66.3327 38.0833Z"
      fill="#E90102"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M45.5783 94.5455C20.4665 93.5379 0.416016 72.8589 0.416016 47.4998C0.416016 21.4957 21.4952 0.416504 47.4993 0.416504C73.5035 0.416504 94.5827 21.4957 94.5827 47.4998C94.5827 73.504 73.5035 94.5832 47.4993 94.5832H46.8543C46.4274 94.5832 46.0021 94.5706 45.5783 94.5455ZM17.286 77.2094C16.9339 76.1985 16.8141 75.1212 16.9354 74.0576C17.0567 72.994 17.4159 71.9714 17.9865 71.0657C18.5571 70.1599 19.3244 69.3943 20.2313 68.8257C21.1383 68.257 22.1617 67.9 23.2255 67.781C41.5786 65.7493 53.5331 65.933 71.7967 67.8233C72.862 67.9343 73.8879 68.2869 74.7963 68.8542C75.7047 69.4216 76.4717 70.1887 77.0388 71.0973C77.6059 72.0059 77.9582 73.0319 78.0689 74.0972C78.1796 75.1625 78.0457 76.239 77.6774 77.2447C85.5053 69.3253 89.8889 58.635 89.8743 47.4998C89.8743 24.0971 70.9021 5.12484 47.4993 5.12484C24.0966 5.12484 5.12435 24.0971 5.12435 47.4998C5.12435 59.0729 9.76441 69.5631 17.286 77.2094Z"
      fill="#212121"
      fill-opacity="0.32"
    />
  </svg>
);
export const emailIcon = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.64453 20.1328C4.09453 20.1328 3.62386 19.9371 3.23253 19.5458C2.8412 19.1545 2.6452 18.6835 2.64453 18.1328V6.13281C2.64453 5.58281 2.84053 5.11215 3.23253 4.72081C3.62453 4.32948 4.0952 4.13348 4.64453 4.13281H20.6445C21.1945 4.13281 21.6655 4.32881 22.0575 4.72081C22.4495 5.11281 22.6452 5.58348 22.6445 6.13281V18.1328C22.6445 18.6828 22.4489 19.1538 22.0575 19.5458C21.6662 19.9378 21.1952 20.1335 20.6445 20.1328H4.64453ZM20.6445 8.13281L13.1695 12.8078C13.0862 12.8578 12.9989 12.8955 12.9075 12.9208C12.8162 12.9461 12.7285 12.9585 12.6445 12.9578C12.5605 12.9571 12.4732 12.9448 12.3825 12.9208C12.2919 12.8968 12.2042 12.8591 12.1195 12.8078L4.64453 8.13281V18.1328H20.6445V8.13281ZM12.6445 11.1328L20.6445 6.13281H4.64453L12.6445 11.1328ZM4.64453 8.38281V6.90781V6.93281V6.92081V8.38281Z"
      fill="black"
    />
  </svg>
);
export const passwordIcon = (
  <svg
    width="17"
    height="22"
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.64453 21.5703C2.09453 21.5703 1.62386 21.3746 1.23253 20.9833C0.841198 20.592 0.645198 20.121 0.644531 19.5703V9.57031C0.644531 9.02031 0.840531 8.54965 1.23253 8.15831C1.62453 7.76698 2.0952 7.57098 2.64453 7.57031H3.64453V5.57031C3.64453 4.18698 4.1322 3.00798 5.10753 2.03331C6.08286 1.05865 7.26186 0.57098 8.64453 0.570313C10.0272 0.569647 11.2065 1.05731 12.1825 2.03331C13.1585 3.00931 13.6459 4.18831 13.6445 5.57031V7.57031H14.6445C15.1945 7.57031 15.6655 7.76631 16.0575 8.15831C16.4495 8.55031 16.6452 9.02098 16.6445 9.57031V19.5703C16.6445 20.1203 16.4489 20.5913 16.0575 20.9833C15.6662 21.3753 15.1952 21.571 14.6445 21.5703H2.64453ZM2.64453 19.5703H14.6445V9.57031H2.64453V19.5703ZM8.64453 16.5703C9.19453 16.5703 9.66553 16.3746 10.0575 15.9833C10.4495 15.592 10.6452 15.121 10.6445 14.5703C10.6439 14.0196 10.4482 13.549 10.0575 13.1583C9.66686 12.7676 9.19586 12.5716 8.64453 12.5703C8.0932 12.569 7.62253 12.765 7.23253 13.1583C6.84253 13.5516 6.64653 14.0223 6.64453 14.5703C6.64253 15.1183 6.83853 15.5893 7.23253 15.9833C7.62653 16.3773 8.0972 16.573 8.64453 16.5703ZM5.64453 7.57031H11.6445V5.57031C11.6445 4.73698 11.3529 4.02865 10.7695 3.44531C10.1862 2.86198 9.47786 2.57031 8.64453 2.57031C7.8112 2.57031 7.10286 2.86198 6.51953 3.44531C5.9362 4.02865 5.64453 4.73698 5.64453 5.57031V7.57031Z"
      fill="black"
    />
  </svg>
);
export const LoadingIcon = (
  <svg
    className="w-5 h-5 mr-2 text-white animate-spin"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8v8H4z"
    ></path>
  </svg>
);
